import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	NAT_CONFIG_FILTER_EVENT,
	NAT_CONFIG_FOCUS_EVENT,
	NAT_CONFIG_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.nat_configs']);

/**
 * Open the NAT accordion on the Templates page.
 *
 * Event-based rather than a DOM click, the way the SSID Template and
 * SSID Schedule sections on this page already are: the page owns which
 * accordion is expanded, and it scrolls the panel into view before it
 * reports back. Retried until the page mounts, so arriving here from
 * another route works as well as already standing on it.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openNatConfigSection() {
	return openResourceSection(
		NAT_CONFIG_SECTION_EVENT,
		'profile.nat_configs',
		SECTIONS,
	);
}

/**
 * Filter the NAT profile table to a search term.
 *
 * The table asks Canvas for the matching page rather than filtering the
 * rows it happens to be showing, so a profile on any page is findable.
 *
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyNatConfigFilter(query) {
	return dispatchAcknowledgedEvent(NAT_CONFIG_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'nat_config',
	});
}

/**
 * Point at one NAT profile's row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusNatConfig(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_nat_config_focus'));
	return dispatchAcknowledgedEvent(NAT_CONFIG_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'nat_config',
	});
}
